import "./DownloadLinkBlock.scss";
import { Button, Link } from "/App.Components";
import { DownloadLinkBlockProps } from "/Models/Generated/DownloadLinkBlockProps";
import { getIcon } from "/Components/Icons/IconLookup";
import cn from "classnames";

const PublicationDownloadBlock = ({
  icon,
  buttonText,
  largeIcon,
  link,
}: DownloadLinkBlockProps) => (
  <div
    className={cn("download-link-block", {
      "download-link-block--large-icon": largeIcon,
    })}
  >
    {link && (
      <div className="download-link-block__link-wrapper">
        <Link
          {...link}
          icon={getIcon(icon) ?? undefined}
          iconThickness={largeIcon ? "Light" : "Reg"}
          iconPlacement="before"
          iconSize={largeIcon ? "32" : "20"}
          size={largeIcon ? "small" : "x-small"}
          fixedIcon
        />
      </div>
    )}
    <div className="download-link-block__button-wrapper">
      <Button
        label={buttonText ?? ""}
        href={link?.href}
        target={link?.target}
        size="s"
        style="primary"
      />
    </div>
  </div>
);

export default PublicationDownloadBlock;
